export default __webpack_public_path__ + "static/media/KAKEHASHIHeader.5effa3bf.png";